import styled, { css } from "styled-components";

interface CommentItemStyleProps {
  $linked?: boolean;
}

export const CommentItem = styled.li<CommentItemStyleProps>`
  display: flex;
  width: 100%;
  padding: 16px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  flex-direction: column;
  gap: 16px;

  ${(props) =>
    props.$linked === true &&
    css`
      box-shadow: ${(props) => props.theme.shadows.box};
    `};

  ${(props) =>
    props.$linked === false &&
    css`
      border: 1px solid ${(props) => props.theme.colors.black5};
    `};
`;

export const CommentText = styled.div`
  display: flex;
  font-size: 1.4rem;
  line-height: 150%;
  flex-direction: column;
  gap: 6px;
  white-space: pre-line;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 130%;
  }
`;

export const CommentDate = styled.div`
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.2rem;
  text-align: right;
`;
